import React, { useRef } from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import { ResponseProvider } from "./Context/ResponseContext";
import Hero from "./Components/Hero";
import Table from "./Components/Table";
import Features from "./Components/Features";
import Navbar from "./Components/Navbar";
import FLow from "./Components/FLow";
import Footer from "./Components/Footer";
import Documentation from "./Components/Documentation";
import Login from "./Components/Login";
import Result from "./Components/Result";
import Demo from "./Components/Demo";
import CTA from "./Components/CTA";

function App() {
  const resultRef = useRef(null);

  return (
    <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <AppContent resultRef={resultRef} />
    </Router>
  );
}

function AppContent({ resultRef }) {
  const location = useLocation();

  return (
    <>
      {location.pathname !== "/result" && <Navbar />}
      <Routes>
        <Route path="/" element={
          <>
            <Hero />
            <FLow />
            <Features />
            <CTA />
            <Footer />
          </>
        } />
        <Route path="/login" element={<Login />} />
        <Route path="/demo" element={<Demo resultRef={resultRef} />} />
        <Route path="/result" element={<Result />} />
      </Routes>
    </>
  );
}

export default App;